
// Definición de defaults

export const defaultTipoPrestacion: TipoPrestacionProps = {
    idTipoPrestacion:  0,
    descripcion:    '',
    activo:         false
};

// Creación de interfaces

export interface TipoPrestacionProps{
    idTipoPrestacion:  number;
    descripcion:    string;
    activo:         boolean;
}
